export default __webpack_public_path__ + "static/media/nobel-pic-3.cfa30333.png";